export default "__VITE_ASSET__1c188785__"